<template>
  <div ref="content" @dragover.stop="$event.preventDefault()" @drop.stop="handleDrop" />
</template>
<script>
import { mapGetters } from "vuex";

import { initBpmnModeler } from "./constant";

const checkBpmnList = [
  "bpmn:UserTask",
  "bpmn:ServiceTask",
  "bpmn:EndEvent",
  "bpmn:ExclusiveGateway"
];

const editBpmnList = ["bpmn:UserTask", "bpmn:ServiceTask", "bpmn:SequenceFlow"];

export default {
  props: {
    initProcessConfig: {
      type: Object
    }
  },
  watch: {
    initProcessConfig: {
      deep: true,
      handler(newValue, oldValue) {
        this.$nextTick(() => {
          this.initProcessTemplate(this.initProcessConfig.template);
        });
      }
    }
  },
  data() {
    return {
      bpmnModeler: null
    };
  },
  computed: {
    ...mapGetters(["currentEnterprise"]),

    modeling() {
      return this.bpmnModeler && this.bpmnModeler.get("modeling");
    },

    commandStack() {
      return this.bpmnModeler && this.bpmnModeler.get("commandStack");
    },

    canvas() {
      return this.bpmnModeler && this.bpmnModeler.get("canvas");
    },

    rootElement() {
      return this.canvas && this.canvas.getRootElement();
    },

    overlays() {
      return this.bpmnModeler && this.bpmnModeler.get("overlays");
    },

    eventBus() {
      return this.bpmnModeler && this.bpmnModeler.get("eventBus");
    },

    moddle() {
      return this.bpmnModeler && this.bpmnModeler.get("moddle");
    },

    cli() {
      return window.cli;
    }
  },

  mounted() {
    this.bpmnModeler = initBpmnModeler(this.$refs.content);
    this.$emit("byModdle", this.moddle);
    this.$emit("byModeling", this.modeling);
    this.$emit("byEventBus", this.eventBus);

    this.eventBus.on("element.click", 0, event => {
      const el = event.element;

      if (!this.canEditCurrentNode(el)) return false;

      this.$emit("byCurrentEditNode", el);
      return true;
    });
  },

  methods: {
    handleDrop(event) {
      event.preventDefault();
      this.createdBpmnNode(event);
    },

    //拖拽生成bpmn节点
    createdBpmnNode(ev) {
      if (!window.draggingNode) return;

      let el = this.createBpmnNode(window.draggingNode, ev);

      this.setBpmnNodeStyle(el);

      this.setBpmnBusinessObject(el, window.draggingNode);

      this.eventBus.fire("element.changed", { element: el });

      window.draggingNode = null;
    },

    createBpmnNode(node, ev) {
      const viewbox = this.canvas.viewbox();
      const id = this.cli.create(
        node.data.type,
        {
          x: ev.offsetX + viewbox.x,
          y: ev.offsetY + viewbox.y
        },
        this.rootElement.businessObject.id
      );
      return this.cli.element(id);
    },

    setBpmnBusinessObject(el, node) {
      el.businessObject.name = node.data.label;

      el.businessObject = Object.assign(el.businessObject, node.data, {
        id: this.getBpmnNodeId(node.data.id)
      });

      delete el.businessObject.label;
    },

    setBpmnNodeStyle(el) {
      let [width, height] = [170, 80];

      if (el.type === "bpmn:ExclusiveGateway") {
        [width, height] = [65, 60];
      }
      el.width = el.businessObject.di.bounds.width = width;
      el.height = el.businessObject.di.bounds.height = height;
    },

    getBpmnNodeId(typeCode) {
      return typeCode + "_" + new Date().getTime();
    },

    //当前节点是否可以编辑
    canEditCurrentNode(bpmnNode) {
      if (editBpmnList.indexOf(bpmnNode.type) === -1) {
        return false;
      }

      if (bpmnNode.businessObject.id === "Initiator") {
        return false;
      }

      if (bpmnNode.type === "bpmn:SequenceFlow") {
        if (
          bpmnNode.businessObject.sourceRef.$type === "bpmn:ExclusiveGateway"
        ) {
          return true;
        }
        return false;
      }

      return true;
    },

    initProcessTemplate(diagramXML) {
      this.bpmnModeler.importXML(diagramXML, err => {
        this.$emit("byRootElement", this.rootElement);

        this.addModelerListener();

        if (err) {
          this.$Message.error(err);
        }
      });
    },

    clearSymbols() {
      const elements = this.cli.elements();
      for (let node of elements) {
        let el = this.cli.element(node);
        this.overlays.remove({ element: el });
      }
    },

    validateSequenceFlow() {
      if (!this.checkBpmnRules()) return;

      let elements = this.cli
        .elements()
        .filter(
          item => this.cli.element(item).type === "bpmn:ExclusiveGateway"
        );

      if (!this.checkProcessApproverNode()) return false

      let condition = -1;
      const gateway = elements.findIndex(item => {
        condition = this.cli.element(item).outgoing.findIndex(el => {
          return el.businessObject.documentation[0].text === "{}";
        });

        return condition >= 0;
      });

      if (gateway >= 0) {
        this.$confirm(
          `您的${gateway + 1}分支优先级为${condition +
            1}的条件，没有设置任何判断，系统默认所有情况均符合该条件判定，您确定保存本次流程设置吗？`,
          "提示",
          {
            confirmButtonText: "确定",
            type: "warning"
          }
        ).then(_ => {
          this.saveModifyProcess();
        });
      } else {
        this.saveModifyProcess();
      }
    },



    checkProcessApproverNode() {
      let elements = this.cli
      .elements()
      .filter(
        item => checkBpmnList.indexOf(this.cli.element(item).type) !== -1
      );
      const processList = ["travelReimburseApply", "commonReimburseApply", "loanApply"];
      const toggle = processList.find(item => item === this.$route.query.processType)

      if (!toggle) return true

      const financeNode = elements.find(item => {
        var el = this.cli.element(item);
        return el.businessObject.id.startsWith("Finance")
      })
      if (!financeNode) {
        this.$Message.error("当前流程必须设置财务节点")
        return false
      }

      const cashier = elements.find(item => {
        var el = this.cli.element(item);
        return el.businessObject.id.startsWith("Cashier")
      })
      if (!cashier) {
        this.$Message.error("当前流程必须设置出纳节点")
        return false
      }

      return true
    },


    checkBpmnRules() {
      this.clearSymbols();
      let elements = this.cli
        .elements()
        .filter(
          item => checkBpmnList.indexOf(this.cli.element(item).type) !== -1
        );

      let failedElements = elements.filter(item => {
        var el = this.cli.element(item);

        if (el.type === "bpmn:EndEvent") {
          return !el.incoming.length;
        }

        return !el.incoming.length || !el.outgoing.length;
      });

      if (!failedElements.length) {
        return true;
      }

      failedElements.forEach(item => {
        let el = this.cli.element(item);
        this.overlays.add(el, {
          position: {
            top: -20,
            right: 0
          },
          html: '<i class="el-icon-warning-outline loader"></i>'
        });
      });

      this.$Message.error("不完整的流程设计！请检查后重新提交");
      return false;
    },

    isGatewayNode(gateway) {
      return gateway && gateway.businessObject.id.startsWith("Gateway");
    },

    getGateway(e) {
      var elementRegistry = this.bpmnModeler.get("elementRegistry");
      var shape = elementRegistry.get(e.element.id);

      return elementRegistry.get(shape.source && shape.source.id);
    },

    setPriority(gateway) {
      gateway.outgoing.forEach((item, index) => {
        this.modeling.updateProperties(item, { name: `优先级${index + 1}` });
      });
    },

    changePriorityByRemove(e) {
      let gateway = this.getGateway(e);
      if (!this.isGatewayNode(gateway)) return;

      setTimeout(_ => {
        this.setPriority(gateway);
      }, 0);
    },

    changePriorityByAdd(e) {
      setTimeout(_ => {
        let gateway = this.getGateway(e);
        if (!this.isGatewayNode(gateway)) return;

        this.setPriority(gateway);
      }, 0);
    },

    addModelerListener() {
      this.bpmnModeler.on("connection.remove", e => {
        this.changePriorityByRemove(e);
      });

      this.bpmnModeler.on("connection.add", e => {
        this.changePriorityByAdd(e);
      });

      this.bpmnModeler.on("shape.add", e => {
        this.addShape(e);
      });
    },

    addShape(e) {
      setTimeout(_ => {
        var shape = this.getShape(e.element.id);
        const id = shape.businessObject.id;

        const canModify = this.canEditCurrentNode(shape);

        if (canModify) {
          this.$emit("byCurrentEditNode", shape);
        }
      });
    },

    getShape(id) {
      var elementRegistry = this.bpmnModeler.get("elementRegistry");
      return elementRegistry.get(id);
    },

    isInvalid(param) {
      // 判断是否是无效的值
      return param === null || param === undefined || param === "";
    },
    isSequenceFlow(type) {
      // 判断是否是线
      return type === "bpmn:SequenceFlow";
    },

    saveModifyProcess() {
      this.setRootElementExtension(this.rootElement);

      this.bpmnModeler.saveXML({ format: true }, (err, xml) => {
        this.$api
          .editProcess(xml, this.initProcessConfig.processId)
          .then(res => {
            if (res && res.length) {
              this.$Message.error(res[0].problem);
            } else {
              this.$Message.success("提交成功！");
              this.$router.push({
                path: "processList"
              });
            }
          });
      });
    },

    setRootElementExtension(element) {
      if (element.businessObject.extensionElements) {
        return;
      }
      this.setExtensionElements(element.businessObject);
      this.setEventListener(element.businessObject);
    },

    setExtensionElements(bpmnNode) {
      var extensionElements = this.moddle.create("bpmn:ExtensionElements");
      bpmnNode.extensionElements = extensionElements;
    },

    setEventListener(bpmnNode) {
      var taskListener = this.moddle.create("flowable:EventListener");
      taskListener.events = "MULTI_INSTANCE_ACTIVITY_STARTED";
      taskListener.delegateExpression = "${multiInstanceStartListener}";
      bpmnNode.extensionElements.set("values", []);
      bpmnNode.extensionElements.values.push(taskListener);
    }
  }
};
</script>
<style lang="scss">
@import "~bpmn-js/dist/assets/diagram-js.css";
@import "~bpmn-js/dist/assets/bpmn-font/css/bpmn-embedded.css";

/* 禁用logo */
.bjs-powered-by {
  display: none;
}

.loader {
  font-size: 20px;
  color: red;
}

/* 左侧菜单栏 */
.djs-palette-entries {
  display: none;
}
</style>
